import { Component, OnInit } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from 'src/app/state/actions';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  role: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  isLinkActive: boolean = false;
  showChevronSettings: boolean = true;
  showReports: boolean = true;
  showQueues: boolean = true;
  showPayments: boolean = true;
  failedsignature: any;
  failedROE: any;
  firstName: any;
  waddelCustomer: any;
  environment=environment

  constructor(
    private logger: LoggerService,
    private http:HttpClient,private router: Router,
    private store: Store<{ languageData: [] }>
  ) {
    this.languageData$ = store.select(selectLanguageData);
   }

  ngOnInit(): void {
    this.getLanguageTokens()
    this.role = sessionStorage.getItem('role');

  }

  dropdownOpen = false;
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.dropdownOpen = false;
  }

  public getLanguageTokens(){
    // let body= {
    //   "project":"Admin Portal",
    //   "url":"Sidebar"
    // }
    // this.http
    // .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
    // .subscribe(
    //   (response: any) => {
    //     console.log(response)
    //     this.lang = {};
    //     // this.languageData = response.strings
    //     this.selectedLanguage = sessionStorage.getItem("language")
    //     for (let token of response.strings) {
    //       this.lang[token.key] = token[this.selectedLanguage];
    //     }
    //     console.log(this.lang)
    //   })

    this.store.dispatch(loadLanguageData());
    
    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })
  }
  toggleChevron5() {
    if (this.role == 'ADMINISTRATOR') {
      this.showChevronSettings = !this.showChevronSettings;
    }
  }

  toggleReports() {
    if (this.role == 'ADMINISTRATOR') {
      this.showReports = !this.showReports;
    }
  }

  toggleQueues() {
    if (this.role == 'ADMINISTRATOR') {
      this.showQueues = !this.showQueues;
    }
  }

  getCustomerData(customer?:any) {
    // let customerDataEndpoint = '/customer/' + this.customerid + '/details';
    // this.http.get(api.url + customerDataEndpoint, {
    //   headers: {
    //     Authorization: 'Bearer ' + this.accessToken,
    //     'Content-Type': 'application/json',
    //   }
    // }).subscribe((response: any) => {
    //   if (response.status == 200) {
        const response = {data:customer}
        this.failedsignature = response.data.failedDocs

        this.failedROE = response.data.newroes[0]

        this.firstName = response.data.firstName
        this.waddelCustomer = response.data.serviceType.waddelCustomer



    //   }
    //   else {
    //     Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
    //   }
    // }, (error) => {
    //   Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    // });
  }
  
  togglePayments() {
    if (this.role == 'ADMINISTRATOR') {
      this.showPayments = !this.showPayments;
    }
  }
}
